import { Box, SxProps, useTheme } from "@mui/material";

type EmptyFieldworkerPlaceholderProps = {
    size?: "default" | "small";
    sx?: SxProps;
};

export function EmptyFieldworkerPlaceholder({ size = "default", sx = {} }: EmptyFieldworkerPlaceholderProps) {
    const theme = useTheme();
    const sizeInPixels = size === "small" ? 25 : 40;
    return (
        <Box sx={{ ...sx, display: "flex" }}>
            <svg
                width={sizeInPixels}
                height={sizeInPixels}
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <circle cx="21" cy="21" r="20" stroke={theme.palette.grey[500]} strokeWidth="2" strokeDasharray="4 4" />
            </svg>
        </Box>
    );
}
